import { createListenerMiddleware } from '@reduxjs/toolkit'
import { RESTORE_HISTORICAL_ACTIONS } from 'actions/actionConstants'
import { storeHistoricalActions } from 'storage/historicalActions'

export const historicalActionsPersistenceMiddleware = createListenerMiddleware<App.State>()

historicalActionsPersistenceMiddleware.startListening({
  predicate: (action, currentState, prevState) => {
    return (
      currentState.system.features.historicalActions !== prevState.system.features.historicalActions &&
      action.type !== RESTORE_HISTORICAL_ACTIONS
    )
  },
  effect: async(_, listenerApi) => {
    const state = listenerApi.getState()
    storeHistoricalActions(state.system.features.historicalActions)
  },
})
